
import api from '../../../services/api';

export interface Order {
  id: string;
  orderNumber: string;
  customer: string;
  date: string;
  status: string;
  quantity: number;
  total: number;
  paymentMethod: string;
  cogs: number;
  channel: string;
}

interface ApiResponse {
  recent_transactions: {
    order_number: string;
    name: string;
    date: string;
    status: string;
    quantity: number;
    total: number;
    payment_method: string;
    cogs: number;
    channel: string;
  }[];
}

export const fetchRecentTransactions = async (limit = 40): Promise<Order[]> => {
  const { data } = await api.get<ApiResponse>('/api/recent_transactions', {
    params: { limit },
  });

  

  if (!data || !data.recent_transactions) {
    console.warn('No recent_transactions found in API response', data);
    return [];
  }

  return data.recent_transactions.map((tx) => ({
    id: tx.order_number,
    orderNumber: tx.order_number,
    customer: tx.name,
    date: tx.date,
    status: tx.status,
    quantity: tx.quantity,
    total: tx.total,
    paymentMethod: tx.payment_method,
    cogs: tx.cogs,
    channel: tx.channel,
  }));
};
